/* @flow */

import type { ScrollOptions } from './types';

const isTabHidden: () => boolean = () => document?.hidden ?? false;

const smoothScrollIntoView: (container: HTMLElement, element: HTMLElement, options: ScrollOptions) => Promise<void> = (container, element, options) =>
  new Promise((resolve) => {
    const FRAME_COUNT_THRESHOLD = 2;
    let same = 0;
    let lastPosTop = container.scrollTop;

    const checkForScrollEnd = () => {
      const newPosTop = container.scrollTop;

      if (newPosTop === lastPosTop) {
        same += 1;
        if (same > FRAME_COUNT_THRESHOLD) {
          resolve();
        }
      } else {
        same = 0;
        lastPosTop = newPosTop;
      }

      window.requestAnimationFrame(checkForScrollEnd);
    };

    element.scrollIntoView({
      ...options,
      behavior: 'smooth',
    });
    window.requestAnimationFrame(checkForScrollEnd);
  });

const openFooterPage: (urlStr: string, windowName: string) => void = (urlStr, windowName) => {
  const url = new URL(urlStr);
  url.searchParams.set('webview', 'false');

  window.open(url.toString(), windowName);
};

export { isTabHidden, openFooterPage, smoothScrollIntoView };
